import api from './api/axiosConfig';

const analyticsService = {
  // Get comprehensive analytics dashboard data
  async getComprehensiveDashboard() {
    try {
      const response = await api.get('/analytics/comprehensive-dashboard/');
      return response.data;
    } catch (error) {
      console.error('Error fetching comprehensive dashboard:', error);
      throw error;
    }
  },

  // Get real-time analytics data
  async getRealTimeAnalytics() {
    try {
      const response = await api.get('/analytics/real-time/');
      return response.data;
    } catch (error) {
      console.error('Error fetching real-time analytics:', error);
      throw error;
    }
  },

  // Get geographic analytics data
  async getGeographicAnalytics(days = 30) {
    try {
      const response = await api.get(`/analytics/geographic/?days=${days}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching geographic analytics:', error);
      throw error;
    }
  },

  // Get analytics data with time period
  async getAnalyticsData(days = 30) {
    try {
      const response = await api.get(`/analytics/comprehensive-dashboard/?days=${days}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching analytics data:', error);
      throw error;
    }
  }
};

export default analyticsService;
